export default "__VITE_ASSET__a15cc51f__"